import {
    getCalendarGroups,
    getCalendarsForCalendarGroup,
} from 'owa-calendar-surface-calendars-store';

import type { Calendar } from 'owa-calendar-cache';
import { findInArray } from 'owa-calendar-data-utils/lib/findInArray';
import { trace } from 'owa-trace';

export function findIndexToInsertCalendarAt(
    calendars: Calendar[],
    userIdentity: string,
    parentGroupId: string
): number {
    let calIndex: number;

    // Get calendars that match the given calendar's group
    const filteredCalendars = getCalendarsForCalendarGroup(userIdentity, parentGroupId);

    // If the parent group has calendars, return the index of the last calendar
    // in the group, else find a previous group which has calendars and
    // return the index of the last calendar of that group.
    if (filteredCalendars.length > 0) {
        const lastCalendar = filteredCalendars[filteredCalendars.length - 1];
        calIndex = findCalendarIndex(calendars, lastCalendar.id.id);
    } else {
        const calendarGroups = getCalendarGroups();
        const findGroupResult = findInArray(
            calendarGroups,
            group =>
                group.serverGroupId === parentGroupId &&
                group.calendarGroupId.mailboxInfo.userIdentity === userIdentity
        );

        if (findGroupResult) {
            let currIndex: number = findGroupResult.index - 1;
            let prevCalId: string;

            // Find a group before the given group that's not empty.
            // If a group is not found return 0.
            while (!prevCalId && currIndex >= 0) {
                const prevGroup = calendarGroups[currIndex--];
                const calendars = getCalendarsForCalendarGroup(
                    userIdentity,
                    prevGroup.serverGroupId
                );
                prevCalId = calendars.length > 0 ? calendars[calendars.length - 1].id.id : null;
            }
            calIndex = !!prevCalId ? findCalendarIndex(calendars, prevCalId) : 0;
        } else {
            trace.warn('Unable to find the given calendars parent group');
        }
    }

    return calIndex;
}

function findCalendarIndex(calendars: Calendar[], calendarId: string): number | undefined {
    let findResult = findInArray(calendars, item => {
        return !!calendarId && item.id.id == calendarId;
    });

    return findResult ? findResult.index + 1 : undefined;
}
